import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import HistoricoImportacaoBaseComponent from "../../../../shared/importacao-lote/abstract/historico-importacao-base.component";
import { EColumnType } from "../../../../shared/importacao-lote/components/table/EColumnType";
import { EImportacaoType } from "../../../../shared/importacao-lote/components/table/EImportacaoType";
import { ITableProps } from "../../../../shared/importacao-lote/components/table/ITableProps";
import { FilterService } from "../../../../shared/importacao-lote/utils/filter.service";
import { mapEnumToLabelObject } from "../../../../shared/importacao-lote/utils/mapEnumToLabelObject";
import { FormField } from "../../../../shared/interfaces/FormField";
import { HttpService } from "../../../../shared/services/http/http-client.service";
import { OrigemImportacao, OrigemImportacaoService } from "../../../importacao-lote/utils/origem-importacao.service";
import { CommonService } from "../../../../shared/services/commom.service";

enum EStatusLoteImportacaoFuncionarioEnum {
  EM_VALIDACAO = "Processando",
  ABERTO = "Em Aberto",
  FINALIZADO = "Finalizado",
  CANCELADO = "Cancelado",
  ERRO = "Erro planilha",
  PROCESSADO_COM_FALHA = "Erro importação",
}

@Component({
  selector: "ngx-historico-importacao-funcionario",
  templateUrl: "./historico-importacao-funcionario.component.html",
  styleUrls: ["./historico-importacao-funcionario.component.scss"],
})
export class HistoricoImportacaoFuncionarioComponent extends HistoricoImportacaoBaseComponent {
  public cargaFormFields: FormField[];
  isProdutoMigrado: boolean = false;

  public tableColumns: Array<ITableProps> = [
    { prop: "action", name: "", type: EColumnType.ACTION },
    { prop: "id", name: "ID", type: EColumnType.NUMBER },
    { prop: "nomeArquivo", name: "Nome arquivo", type: EColumnType.STRING },
    { prop: "dataCadastro", name: "Data de criação", type: EColumnType.DATE },
    { prop: "totalErros", name: "Erros cadastro", type: EColumnType.NUMBER },
    {
      prop: "totalRegistros",
      name: "Total cadastrado",
      type: EColumnType.NUMBER,
    },
    { prop: "status", name: "Status", type: EColumnType.ENUM },
  ];

  constructor(
    private http: HttpService,
    private readonly myRouter: Router,
    private readonly myActivatedRoute: ActivatedRoute,
    origemService: OrigemImportacaoService,
    private readonly commonService: CommonService,
    private readonly filterService: FilterService
  ) {
    super(
      myRouter,
      myActivatedRoute,
      origemService,
      EImportacaoType.FUNCIONARIO
    );
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.verificarMigracaoRollout();
    this.cargaFormFields = [
      {
        name: "id",
        label: "Id cadastro",
        placeholder: "Digite",
        type: "text",
        value: "",
      },
      {
        name: "nomeArquivo",
        label: "Nome arquivo",
        placeholder: "Digite",
        type: "text",
        value: "",
      },
      {
        name: "dataCadastro",
        label: "Data",
        placeholder: "Digite",
        type: "datepicker",
        value: "",
      },
      {
        name: "status",
        label: "Status",
        placeholder: "Selecione",
        type: "select",
        value: "",
        options: mapEnumToLabelObject(
          EStatusLoteImportacaoFuncionarioEnum,
          this.enumMap
        ),
      },
    ];

    this.getSubtituloHistorico();
  }

  findImportacao(): void {
    this.http.doGet(
      `/importacao-funcionario/lotes/resumo-processamento?gerarCartao=${this.emitirCartao}`,
      "",
      (response) => {
        this.validarLotes(response);
        this.showStatusEmitter(true);
      }
    );
    if (this.showStatus) {
      this.intervalId = setInterval(() => {
        this.http.doGet(
          `/importacao-funcionario/lotes/resumo-processamento?gerarCartao=${this.emitirCartao}`,
          "",
          (response) => {
            this.validarLotes(response);
            this.showStatusEmitter(true);
          }
        );
      }, 10000);
    }
  }

  navigate() {
    this.myRouter.navigate(["validar-importacao"], {
      relativeTo: this.myActivatedRoute.parent,
      queryParams: { loteId: this.loteId },
    });
  }

  filter(event) {
    const properties = ["id", "nomeArquivo", "dataCadastro", "status"];
    this.filters = this.filterService.generateFilter(event, properties);
  }

  action(): void {
    this.myRouter.navigate(["importar-arquivo"], {
      relativeTo: this.myActivatedRoute.parent,
    });
  }

  getSubtituloHistorico(): string {
    if (this.origemImportacao === OrigemImportacao.GestaoCartaoNoName) {
      return 'Cadastre seus colaboradores por planilha. Os cartões não são gerados automaticamente, lembre-se de solicitá-los na aba "Solicitar Cartões".';
    } else {
      return 'Cadastre seus colaboradores via planilha e solicite a 1ª via dos cartões: A emissão do cartão é vinculada ao cadastro, com a quantidade de cartões correspondente ao número de colaboradores cadastrados.';
    }
  }

  private verificarMigracaoRollout() {
    this.commonService.isProdutoMigrado().subscribe(isMigrated => {
      this.isProdutoMigrado = isMigrated;
    });
  }
}
